import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IBusiness } from '@/coreDomainsModule/entities/businessBase';
import { SimulateBusinessAdapter } from '../adapters/simulateBusinessAdapter';
import { getOrganizationId } from '@/utils/token';
import { IAggregateBusinessRepository } from '@/coreInfrastructureModule/interfaces/IAggregateBusinessRepository';

/**
 * 取引情報をシステムから取得する
 */
export class GetBusinessUseCase {
  public repository: IAggregateBusinessRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IAggregateBusinessRepository) {
    this.repository = repository;
  }
  /**
   * businessIdにマッチする取引を取得する
   * @param aggregateBusinessId - 取引ID
   * @returns 取引情報
   */
  async Execute(aggregateBusinessId: string): Promise<INetworkResult<IBusiness, Error>> {
    try {
      const orgId = await getOrganizationId();
      const res = await this.repository.getSimulationBusiness(aggregateBusinessId);
      if (res.status.type === 'success') {
        const business: IBusiness = SimulateBusinessAdapter.adapt(res.status.data, orgId);
        return {
          status: {
            type: 'success',
            data: business,
          },
        };
      } else {
        return {
          status: {
            type: 'error',
            error: Error('取得に失敗しました'),
          },
        };
      }
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('原因不明のエラーが発生しました'),
        },
      };
    }
  }
}
